import { requests } from './api-service';

const provinceApi = {
    getProvinces: () => requests.get('provinces'),
};

export default provinceApi;